import React, { useEffect, useState } from "react";
import "./Tools.scss";
import CardLayout from "../../shared/pageLayouts/cardLayout/CardLayout";
import Card from "../../shared/widgets/Card/Card";
import { APIService } from "../../../services/APIService";
import { ServiceURI } from "../../../services/ServiceURI";
import { ITool } from "../../../models/Tool.model";
import CreateLayout from "../../shared/pageLayouts/createLayout/CreateLayout";
import { IForm } from "../../shared/widgets/Form/models/Form.model";
import { Button } from "primereact/button";
import SharedForm from "../../shared/widgets/Form/Form";
import { ToolsCreateForm } from "./ToolsCreateForm";
import { FaTools } from "react-icons/fa";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

interface IToolForm {
  name: string;
  description: string;
  functions: IForm[];
}

const toolForm = {
  name: "",
  description: "",
  functions: ToolsCreateForm,
};

export default function Tools() {
  const [tools, setTools] = useState<ITool[]>([]);
  const [isCreateTab, setIsCreateTab] = useState(false);
  const [form, setForm] = useState<IToolForm>(toolForm);
  const [isEditMode, setIsEditMode] = useState(false);

  const fetchTools = async () => {
    const res = await APIService.getCall(ServiceURI.TOOLS.FATCH_TOOLS);
    if (res) {
      setTools(res);
    }
  };

  const handleAddFunction = () => {
    setForm({ ...form, functions: form.functions.concat(ToolsCreateForm) });
  };

  const handleCardClick = (index: number) => {
    const selectedCard: ITool | null = tools.find((_, i) => i === index) || null;
    if (selectedCard) {
      const newFunctionForm: IForm[] = [];

      selectedCard.functions.forEach((cardItem: any) => {
        ToolsCreateForm.forEach((item) => {
          newFunctionForm.push({ ...item, value: cardItem[item.field] });
        });
      });

      setIsEditMode(true);
      setForm({
        name: selectedCard.name,
        description: selectedCard.description,
        functions: newFunctionForm,
      });
      setIsCreateTab(true);
    }
  };

  useEffect(() => {
    fetchTools();
  }, []);

  return (
    <div className="tools-layout">
      {isCreateTab ? (
        <CreateLayout
          title="Tool"
          contentChildren={ToolContent(
            setIsCreateTab,
            form,
            setForm,
            isEditMode,
            handleAddFunction
          )}
          goBack={() => setIsCreateTab(false)}
        />
      ) : (
        <CardLayout
          title="Tools"
          addButtonClicked={() => {
            setIsEditMode(false);
            setForm(toolForm);
            setIsCreateTab(true);
          }}
        >
          {tools.map((item, i) => {
            return (
              <Card
                key={i}
                icon={<FaTools />}
                item={{
                  title: item.name,
                  content: item.description,
                  logo: item.logo,
                }}
                handleCardClick={() => handleCardClick(i)}
              />
            );
          })}
        </CardLayout>
      )}
    </div>
  );
}

const ToolContent = (
  setIsCreateTab: any,
  form: IToolForm,
  setForm: any,
  isEditMode: boolean,
  handleAddFunction: any
) => {
  const formRender = (
    <div className="create-form-content">
      <div className="tool-form">
        <div className="form-group">
          <label>Name</label>
          <InputText
            value={form.name}
            placeholder="Enter Name"
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>Description</label>
          <InputTextarea
            value={form.description}
            placeholder="Enter Description"
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            rows={5}
            cols={30}
          />
        </div>
        <div className="add-function">
          <Button label="+ Add" onClick={() => handleAddFunction()} />
        </div>

        <SharedForm
          form={form.functions}
          setForm={(functionValue: IForm[]) =>
            setForm({ ...form, functions: functionValue })
          }
        />
      </div>
    </div>
  );

  const footerRender = (
    <div className="create-form-footer">
      <Button
        label="Cancel"
        onClick={() => setIsCreateTab(false)}
        severity="secondary"
        text
      />
      <Button
        label={`${isEditMode ? "Update" : "Create"} Tool`}
        onClick={() => setIsCreateTab()}
        raised
        className="primary"
      />
    </div>
  );

  return (
    <>
      {formRender}
      {footerRender}
    </>
  );
};
